import { render, staticRenderFns } from "./check.vue?vue&type=template&id=78cb4a9a&scoped=true"
import script from "./check.vue?vue&type=script&lang=js"
export * from "./check.vue?vue&type=script&lang=js"
import style0 from "@/styles/wap.scss?vue&type=style&index=0&id=78cb4a9a&prod&lang=scss&scoped=true&external"
import style1 from "./check.vue?vue&type=style&index=1&id=78cb4a9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cb4a9a",
  null
  
)

export default component.exports